import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import * as React from 'react';
import { Calendar, Views, dayjsLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import * as Redux from 'react-redux';
import { BLUE_COLOR } from '../../../../constants/ColorsConst';
import { dateformat, diasDeSemanaUtil } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { SnackbarAlertWidget } from '../../../../widgets';
import {
  setActivoHorariosAction,
  updatedCalendarHorariosAction,
} from '../HorariosAction';
import { ALL_HORARIOS, SETTINGS_HORARIOS } from '../HorariosReducer';
import ScreenCaptureComponent from './CaptureHorarios';

const localizer = dayjsLocalizer(dayjs);
const DragAndDropCalendar = withDragAndDrop(Calendar);

export const messagesCalendar = {
  day: 'Día',
  week: 'Semana',
  agenda: 'Diario',
  month: 'Mes',
  today: 'Hoy',
  previous: 'Anterior',
  next: 'Siguiente',
};

const VistaHorariosComponent = ({ setOpenForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );
  const horariosStore = Redux.useSelector((state) => state.horarios);

  const diasSemanas = [];
  diasDeSemanaUtil.forEach((dia) => {
    const dias =
      loginStore.isEntity || loginStore.isAdmin || loginStore.isAdminTeacher
        ? entHorariosClasesStore.activo.dias
        : docentesStore.activo.diasClases.dias;

    dias.forEach((dx) => {
      if (dia.id === dx.num || dia.dia === dx) {
        diasSemanas.push(dia);
      }
    });
  });

  const [eventos, setEventos] = React.useState([]);
  const [errorMsg, setErrorMsg] = React.useState(null);
  const [minutos, setMinutos] = React.useState(
    entidadesStore.ajustes.minutosAcademicos,
  );
  const [loadingUpdatedCalendar, setLoadingUpdatedCalendar] =
    React.useState(false);

  const formatDate = dateformat(null, { format: 'YYYY-MM-DD' });

  function getDataHorarios(data) {
    let events = [];

    if (entHorariosClasesStore.activo?.bloques.length > 0) {
      entHorariosClasesStore.activo.bloques.forEach((bloque) => {
        if (bloque.break) {
          diasSemanas.forEach((e) => {
            events.push({
              title: 'Libre',
              id: bloque.id,
              horario: null,
              color: 'grey',
              start: dayjs(`${formatDate} ${bloque.start}`).toDate(),
              end: dayjs(`${formatDate} ${bloque.end}`).toDate(),
              resourceId: e.resourceId,
            });
          });
        }
      });
    }

    data.forEach((el) => {
      const rs = diasSemanas.find((rs) => rs.resourceTitle === el.dia);
      events.push({
        id: el.id,
        horario: el,
        color: el.materia.color ?? 'orange',
        start: dayjs(`${formatDate} ${el.horaInicio}`).toDate(),
        end: dayjs(`${formatDate} ${el.horaFinal}`).toDate(),
        resourceId: rs.resourceId,
      });
    });
    return events;
  }

  React.useEffect(() => {
    setEventos(getDataHorarios(horariosStore.all));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [horariosStore.all]);

  React.useEffect(() => {
    if (!horariosStore.params.idDocente && !horariosStore.params.idSeccion) {
      dispatch({
        type: ALL_HORARIOS,
        payload: { data: [] },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [horariosStore.params]);

  const event = (eventProps) => {
    const { event } = eventProps;

    // Personaliza el estilo de cada evento
    const eventStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: horariosStore.params.idNivelAcademico ? 'start' : 'center',
      // color: horariosStore.settings.isColor ? '#2b2b2b' : 'white',
    };

    const styleTextCalendar = {
      fontSize: '9pt',
      fontWeight: 'bold',
      textAlign: horariosStore.params.idNivelAcademico ? 'start' : 'center',
    };

    return (
      <Box sx={eventStyle}>
        {event.horario ? (
          <>
            <Typography sx={styleTextCalendar}>{event.title}</Typography>
            <Typography fontSize="9pt" fontWeight="bold">
              {event.horario.seccion.nivelAcademico.nivelAcademico.abrev}
              {' - '}
              {event.horario.seccion.nombre}
            </Typography>
            {!loginStore.isAdminTeacher && (
              <Typography sx={{ ...styleTextCalendar, fontSize: '8pt' }}>
                {event.horario.docente.usuario.perfil.pnombre}{' '}
                {event.horario.docente.usuario.perfil.papellido}
              </Typography>
            )}

            <Typography
              sx={{
                ...styleTextCalendar,
                fontSize: '8pt',
              }}
            >
              {event.horario.materia.nombre}
            </Typography>
            {!horariosStore.settings.isEstatus && event.horario.aula ? (
              <Typography
                sx={{
                  ...styleTextCalendar,
                  fontSize: '8pt',
                }}
              >
                Aula: {event.horario.aula?.nombre}
              </Typography>
            ) : null}
            {!horariosStore.settings.isEstatus ? null : (
              <Chip
                label={event.horario.estatus.nombre}
                size="small"
                sx={{
                  fontSize: '7pt',
                }}
                color={event.horario.estatus.id === 1 ? 'success' : 'error'}
              />
            )}
          </>
        ) : (
          <>
            <Typography
              sx={{ textAlign: 'start', fontSize: '9pt', width: '100%' }}
            >
              {event.title}
            </Typography>
          </>
        )}
      </Box>
    );
  };

  function handlerValidaHora(slotInfo) {
    let existe = false;

    const horaInicio = dateformat(slotInfo.start, { format: 'HH:mm' });
    const horaFinal = dateformat(slotInfo.end, { format: 'HH:mm' });
    const diaSelect = diasDeSemanaUtil.find(
      (el) => el.id === slotInfo.resourceId,
    );

    horariosStore.all.forEach((el) => {
      if (diaSelect.dia === el.dia) {
        const horaInicioSelect = dayjs(
          dateformat(horaInicio, { complete: true, dateOnly: true }),
        );
        const horaInicioEl = dayjs(
          dateformat(el.horaInicio, { complete: true, dateOnly: true }),
        );
        const horaFinalSelect = dayjs(
          dateformat(horaFinal, { complete: true, dateOnly: true }),
        );
        const horaFinalEl = dayjs(
          dateformat(el.horaFinal, { complete: true, dateOnly: true }),
        );

        const validHoraInicio =
          horaInicioSelect >= horaInicioEl && horaInicioSelect < horaFinalEl;
        const validHoraFinal =
          horaFinalSelect <= horaFinalEl && horaFinalSelect > horaInicioEl;
        if (validHoraInicio || validHoraFinal) {
          setErrorMsg(
            `El horario ${horaInicio}-${horaFinal} se encuentra ocupado por otro registro`,
          );
          existe = true;
        }
      }
    });

    if (!existe) {
      dispatch({
        type: SETTINGS_HORARIOS,
        payload: {
          ...horariosStore.settings,
          newHorario: {
            horaInicio: dateformat(slotInfo.start, { format: 'HH:mm' }),
            horaFinal: dateformat(slotInfo.end, { format: 'HH:mm' }),
            dia: diaSelect,
          },
        },
      });
    }
  }

  const updateCalendarService = async ({ event, start, end, resourceId }) => {
    const find = eventos.filter((el) => el.id !== event.id);
    const horaInicio = dateformat(start, { format: 'HH:mm' });
    const horaFinal = dateformat(end, { format: 'HH:mm' });
    const dia = diasSemanas.find(
      (e) => e.resourceId === resourceId,
    ).resourceTitle;

    const diasAsignados = loginStore.isAdminTeacher
      ? usuEntidadesStore.activo.diasClases.dias
      : event.horario.docente.diasClases.dias;

    if (!diasAsignados.includes(dia)) {
      notify('El día no se encuentra asigando al docente', { warning: true });
      return;
    }

    if (
      dia === event.horario.dia &&
      horaInicio === event.horario.horaInicio &&
      horaFinal === event.horario.horaFinal
    )
      return;

    setEventos([...find, { ...event, start, end, resourceId }]);

    setLoadingUpdatedCalendar(true);
    const res = await updatedCalendarHorariosAction(
      { dispatch, notify },
      event.horario.id,
      {
        dia,
        horaInicio,
        horaFinal,
        idEntidad: entidadesStore.activo.id,
        idHorarioClase: entHorariosClasesStore.activo?.id,
        idMateria: event.horario.materia.id,
        idSeccion: event.horario.seccion.id,
      },
      horariosStore.params,
    );

    if (!res) {
      setEventos([...find, event]);
    }

    setLoadingUpdatedCalendar(false);
  };

  const moveEvent = ({ event, start, end, resourceId }) => {
    updateCalendarService({
      event,
      start,
      end,
      resourceId,
    });
  };

  const dragDropCalendarComponent = (seccion, data) => (
    <Paper elevation={4} sx={{ width: '100%', p: 1 }}>
      {seccion && (
        <center>
          <h4>SECCIÓN "{seccion}"</h4>
        </center>
      )}
      <Stack sx={{ position: 'relative' }}>
        <DragAndDropCalendar
          events={data ?? eventos}
          localizer={localizer}
          timeslots={4}
          defaultView={Views.DAY}
          onEventDrop={moveEvent}
          resizable
          onEventResize={moveEvent}
          step={minutos * 0.25}
          min={
            new Date(
              `${dateformat(null, {})} ${
                entHorariosClasesStore.activo?.start ?? '06:00'
              }`,
            )
          }
          max={
            new Date(
              `${dateformat(null, {})} ${
                entHorariosClasesStore.activo?.end ?? '20:00'
              }`,
            )
          }
          style={{ height: 'auto', backgroundColor: '#c1c1c1c1' }}
          startAccessor="start"
          endAccessor="end"
          resourceIdAccessor="resourceId"
          resourceTitleAccessor="resourceTitle"
          resources={diasSemanas}
          components={{
            event,
            toolbar: () => null,
          }}
          onSelectEvent={(event) => {
            console.log(event);
            setActivoHorariosAction(dispatch, event.horario);
          }}
          eventPropGetter={(event) => {
            let style = {
              backgroundColor: horariosStore.settings.isColor
                ? 'white'
                : event.color ?? '#2b2b2b',
              color: 'white',
              borderRadius: '7px',
              border:
                event.id === horariosStore.activo?.id
                  ? 'solid 3px blue'
                  : event.horario?.estatus.id === 2
                  ? 'solid 1px red'
                  : 'solid 1px white',
              fontSize: '10pt',
            };

            if (event.isMine) {
              style.backgroundColor = 'lightgreen';
            }

            return {
              className: '',
              style,
            };
          }}
        />
        {loadingUpdatedCalendar ? (
          <Box sx={{ width: '100%', height: '100%', backgroundColor: 'red' }}>
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                p: 3,
                top: '0',
                left: '0',
                backgroundColor: 'rgba(0,0,0,.5)',
              }}
            >
              <CircularProgress
                sx={{ color: 'white' }}
                size={50}
                thickness={5}
              />
              <Typography variant="h5" sx={{ color: 'white' }}>
                Actualizando, por favor espere...
              </Typography>
            </Box>
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );

  const calendarioComponent = (seccion, data) => (
    <Paper elevation={4} sx={{ width: '100%', p: 1, mb: 4 }}>
      {seccion && (
        <center>
          <h4>SECCIÓN "{seccion}"</h4>
        </center>
      )}
      <Calendar
        events={data ?? eventos}
        localizer={localizer}
        defaultView={Views.DAY}
        timeslots={4}
        step={minutos * 0.25}
        min={
          new Date(
            `${dateformat(null, {})} ${
              entHorariosClasesStore.activo?.start ?? '06:00'
            }`,
          )
        }
        max={
          new Date(
            `${dateformat(null, {})} ${
              entHorariosClasesStore.activo?.end ?? '20:00'
            }`,
          )
        }
        style={{ height: 'auto' }}
        startAccessor="start"
        endAccessor="end"
        resourceIdAccessor="resourceId"
        resourceTitleAccessor="resourceTitle"
        resources={diasSemanas}
        components={{
          event,
          toolbar: () => null,
        }}
        onSelectEvent={(event) => {
          setActivoHorariosAction(dispatch, event.horario);
          setOpenForm(true);
        }}
        eventPropGetter={(event) => {
          let style = {
            backgroundColor: horariosStore.settings.isColor
              ? 'white'
              : event.color ?? '#2b2b2b',
            color: horariosStore.settings.isColor ? 'black' : 'white',
            borderRadius: '7px',
            border:
              event.horario?.estatus.id === 2 &&
              !horariosStore.settings.isEstatus
                ? 'solid 1.5px red'
                : horariosStore.settings.isColor
                ? 'solid 1px black'
                : 'none',
            fontSize: '10pt',
            '$:hover': {
              backgroundColor: 'grey',
            },
          };

          if (event.isMine) {
            style.backgroundColor = 'lightgreen';
          }

          return {
            className: '',
            style,
          };
        }}
        onSelectSlot={(slotInfo) => {
          setActivoHorariosAction(dispatch, null);
          handlerValidaHora(slotInfo);
        }}
        selectable
      />
    </Paper>
  );

  function getCaledariosBySeccion() {
    const secciones = [];
    const horariosPorSeccion = horariosStore.all.reduce((acc, horario) => {
      const { seccion } = horario;
      if (!acc[seccion.id]) {
        secciones.push(seccion);
        acc[seccion.id] = {
          horarios: [],
        };
      }
      acc[seccion.id].horarios.push(horario);
      return acc;
    }, {});

    secciones.sort((a, b) => {
      if (
        a.nivelAcademico.nivelAcademico.numero ===
        b.nivelAcademico.nivelAcademico.numero
      ) {
        return a.nombre.localeCompare(b.nombre);
      }

      return (
        a.nivelAcademico.nivelAcademico.numero -
        b.nivelAcademico.nivelAcademico.numero
      );
    });

    let seccionesEventos = [];

    secciones.forEach((seccion) => {
      const horarios = horariosPorSeccion[seccion.id].horarios;
      seccionesEventos.push({
        seccion,
        events: getDataHorarios(horarios),
      });
    });

    return seccionesEventos.map((sec) =>
      horariosStore.settings.isEditCalendar
        ? dragDropCalendarComponent(sec.seccion.nombre, sec.events)
        : calendarioComponent(sec.seccion.nombre, sec.events),
    );
  }

  return (
    <>
      {horariosStore.all.length > 0 ? (
        <Box sx={{ position: 'absolute', zIndex: 100 }}>
          <Stack direction="row" spacing={1}>
            <Tooltip describeChild title="Sumar 5 minutos" placement="top">
              <IconButton
                aria-label="delete"
                disabled={minutos === 60}
                onClick={() => {
                  if (minutos !== 60) setMinutos(minutos + 5);
                }}
                sx={{
                  backgroundColor: BLUE_COLOR,
                  color: 'white',
                  '&:hover': {
                    color: 'black',
                  },
                  mr: 0.5,
                }}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip describeChild title="Restar 5 minutos" placement="top">
              <IconButton
                aria-label="delete"
                disabled={minutos === 20}
                onClick={() => {
                  if (minutos !== 10) setMinutos(minutos - 5);
                }}
                sx={{
                  backgroundColor: BLUE_COLOR,
                  color: 'white',
                  '&:hover': {
                    color: 'black',
                  },
                  mr: 0.5,
                }}
              >
                <RemoveIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      ) : null}
      {horariosStore.settings.isAll ? (
        <Box
          sx={{
            display: 'block',
            width: '100%',
            direction: 'column',
          }}
        >
          {getCaledariosBySeccion()}
        </Box>
      ) : horariosStore.params.idNivelAcademico ? (
        horariosStore.settings.isCalendarioSeparados ? (
          <Box
            sx={{
              display: horariosStore.settings.isHorizontal ? 'flex' : 'block',
              width: '100%',
              direction: horariosStore.settings.isHorizontal ? 'row' : 'column',
            }}
          >
            {getCaledariosBySeccion()}
          </Box>
        ) : horariosStore.settings.isEditCalendar ? (
          dragDropCalendarComponent(null, null)
        ) : (
          calendarioComponent(null, null)
        )
      ) : horariosStore.settings.isCut ? (
        <ScreenCaptureComponent children={calendarioComponent(null, null)} />
      ) : horariosStore.settings.isEditCalendar ? (
        dragDropCalendarComponent(null, null)
      ) : (
        calendarioComponent(null, null)
      )}
      <SnackbarAlertWidget
        message={errorMsg}
        warning
        state={() => setErrorMsg(null)}
      />
    </>
  );
};

export default VistaHorariosComponent;
